const $ = jQuery.noConflict();
/* eslint-disable */
'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domBody: $('body'),
	$domBtnForLoader: $('.js-register__btn, .js-login-block__btn, .js-lost-reset-btn, .js-fake-order-btn'),
	$domInputTextarea: $('.wpcf7-form input, .wpcf7-form textarea'),
	$domBtnLoader: $('.js-btn-loader'),
	strCF7Holder: '.js-cf7-holder',
	strForm: '.wpcf7-form',
	strTriggerURL: '#wpcf7-f17-o1',
	classSent: 'form-is-sent',
	classInvalid: 'invalid',
	classVisible: 'is-visible',

	/** @description Initialize */
	init: function() {
		this.checkIfIE();
		this.afterFormSubmit();
		this.formAutofill();
		this.showPassword();
		this.showBtnLoader();
		this.registerRadioButtonsShowFields();
		this.inputNumberPlusMinus();
		this.checkboxAll();

		if ($('body.woocommerce-checkout').length > 0) {
			$(document).on('click', '.js-fake-order-btn', function() {
				$('button#place_order').trigger('click');
			});
			$(document).ajaxComplete(function() {
				console.log(document.querySelector('label[for="payment_method_vpossia"]'));
				if ($('label[for="payment_method_vpossia"]').length > 0) {
					document.querySelector('label[for="payment_method_vpossia"]').firstChild.textContent='VPOS SIA - Platite karticom';
					$('label[for="payment_method_vpossia"]').show();

					// $('.payment_method_vpossia label').append(
					// 	'<span class="custom-image"></span>'
					// );
					$('.payment_method_vpossia img').attr('src', 'https://c3p1yyq8nq.gvozdjara.rs/wp-content/themes/fws-techno-ferum/src/assets/images/checkout-cards-image.jpg');
				}
			});
			// $('.payment_method_vpossia label').append(
			// 	'<span class="custom-image"></span>'
			// );
		}
		const orderDetails = $('.order-status');
		orderDetails.each(function() {
			const textContent = $(this).text();
			if (textContent.includes('Processing')) {
				$(this).addClass('processing');
			} else if (textContent.includes('Completed')) {
				$(this).addClass('completed');
			} else if (textContent.includes('Cancelled')) {
				$(this).addClass('cancelled');
			} else if (textContent.includes('Failed')) {
				$(this).addClass('failed');
			} else if (textContent.includes('Pending payment')) {
				$(this).addClass('pending');
			} else if (textContent.includes('Refunded')) {
				$(this).addClass('refunded');
			} else if (textContent.includes('Shipping')) {
				$(this).addClass('shipping');
			}
		});
		$(document).ready(function() {
			const form = document.getElementById('mc4wp-form-1');
			if (!form) {
				return false;
			}

			function showLoader() {
				$('.site-footer__upper-form-wrap').addClass('btn-clicked');
			}

			function hideLoader() {
				$('.site-footer__upper-form-wrap').removeclass('btn-clicked');
			}

			form.addEventListener('submit', function() {
				showLoader();
				const responseDiv = form.querySelector('.mc4wp-response');
				const observer = new MutationObserver(() => {
					if (responseDiv.innerText.trim() !== '') {
						hideLoader();
						observer.disconnect();
					}
				});
				observer.observe(responseDiv, {childList: true, subtree: true});
			});
		});
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */
	afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent', delay = 5000) => {
		document.addEventListener('wpcf7mailsent', (e) => {
			const formId = e.detail.id;

			FormHelpers.$domBody.addClass('prevent-scroller');
			$(formId).parents(formHolder).addClass(sentClass);

			$('.cf7-holder__popup').addClass('is-active');

			setTimeout(() => {
				$(formHolder).removeClass(sentClass);
			}, delay);
		}, false);
	},
	// If user use Internet Explorer this is custom trigger for Thank you msg for CF7
	checkIfIE() {
		const url = window.location.href;
		if (url.indexOf(FormHelpers.strTriggerURL) > -1 && !$(FormHelpers.strForm).hasClass(FormHelpers.classInvalid)) {
			$(FormHelpers.strForm).parents(FormHelpers.strCF7Holder).addClass(FormHelpers.classSent);

			setTimeout(() => {
				$(FormHelpers.strCF7Holder).removeClass(FormHelpers.classSent);
			}, 5000);
		}
	},

	formAutofill: function() {
		FormHelpers.$domInputTextarea.attr('autocomplete', 'negative');
	},

	showPassword: function() {
		$('.form-pass-icon').on('click', function() {
			const input = $(this).parent().find('input');
			if (input[0].type === 'password') {
				input[0].type = 'text';
				$(this).addClass('is-active');
			} else {
				input[0].type = 'password';
				$(this).removeClass('is-active');
			}
		});
	},

	showBtnLoader: function() {
		FormHelpers.$domBtnForLoader.on('click', function() {
			FormHelpers.$domBtnLoader.addClass(FormHelpers.classVisible);
		});
	},

	registerRadioButtonsShowFields: function() {
		$('#register__inputs--hidden-' + $('[name=radio-group]').val()).show('slow');
		$('[name=radio-group]').on('click', function() {
			$('.register__inputs--hidden').hide();
			$('#register__inputs--hidden-' + $(this).val()).show('slow');
		});
	},

	inputNumberPlusMinus: function() {
		let timer; // Timer identifier
		const waitTime = 1000; // Wait time in milliseconds
		$(document).on('click', '.js-product-quantity__minus', function() {
			clearTimeout(timer);
			const $input = $(this).parent().find('input');
			let count = parseInt($input.val()) - 1;
			count = count < 1 ? 1 : count;
			$input.val(count);
			$input.attr('value', count);
			$input.change();
			const updateBtn = document.querySelector('.js-update-cart-button');
			if (!updateBtn) {
				return false;
			}

			// Wait for X ms and then process the request
			timer = setTimeout(() => {
				updateBtn.click();
			}, waitTime);

			return false;
		});
		$(document).on('click', '.js-product-quantity__plus', function() {
			clearTimeout(timer);
			const $input = $(this).parent().find('input');
			$input.val(parseInt($input.val()) + 1);
			$input.attr('value', parseInt($input.val()) + 1);
			$input.change();
			const updateBtn = document.querySelector('.js-update-cart-button');
			if (!updateBtn) {
				return false;
			}

			// Wait for X ms and then process the request
			timer = setTimeout(() => {
				updateBtn.click();
			}, waitTime);

			return false;
		});
	},

	checkboxAll: function() {
		if ($('.wishlist-block').length) {
			const checkAll = document.getElementById('check-all');
			const otherCheckboxes = document.querySelectorAll('input[type=checkbox]:not(#check-all)');
			if (checkAll) {
				checkAll.addEventListener('change', onCheckAllChange);
				otherCheckboxes.forEach(input => input.addEventListener('change', onOtherCheckboxChange));

				function onCheckAllChange() {
					otherCheckboxes.forEach((input) => input.checked = checkAll.checked);
				}

				function onOtherCheckboxChange() {
					const allChecked = Array.from(otherCheckboxes).every(input => input.checked);
					checkAll.checked = allChecked;
				}
			}

		}
	}
};

export default FormHelpers;
